import { SVGProps } from 'react';

const SvgSmoking = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M440 0c13.3 0 24 10.7 24 24v19c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v19c0 13.3-10.7 24-24 24s-24-10.7-24-24v-19c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43V24c0-13.3 10.7-24 24-24zm176 288c-13.3 0-24-10.7-24-24v-19c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24v19c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8v19c0 13.3-10.7 24-24 24zm-56 88v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24s24 10.7 24 24zm-416 88h208v-64H224v64zM0 416c0-35.3 28.7-64 64-64h384c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64v-32z" />
  </svg>
);
export default SvgSmoking;
